import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { canManageContactData, isGfRole } from "../../../../shared/permissions";
import { INSTANCE } from "../../lib/instance";
import { isCoreInstance } from "../../../../shared/instance";

interface GfOnlyRouteProps {
  children: ReactNode;
  /**
   * "gf" (Default): nur GF. "contactData": GF und Verwaltung, ausschliesslich
   * fuer /hub/stammdaten (Kontaktdatenpflege, Migration 0045).
   */
  scope?: "gf" | "contactData";
}

/**
 * Client-seitige Komfort-Schranke fuer interne Hub-Bereiche.
 * Die verbindliche Zugriffskontrolle erfolgt serverseitig über gfProcedure
 * beziehungsweise verwaltungProcedure.
 */
export function GfOnlyRoute({ children, scope = "gf" }: GfOnlyRouteProps) {
  const { user, isLoading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--color-bg)" }}>
        <span className="text-sm" style={{ color: "var(--color-muted)" }}>Berechtigung wird geprüft…</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const allowed = isCoreInstance(INSTANCE)
    ? scope === "gf" && user?.coreAdministrator === true
    : scope === "contactData"
      ? canManageContactData(user?.roleName, INSTANCE, user?.roleScope)
      : isGfRole(user?.roleName, INSTANCE, user?.roleScope);
  if (!allowed) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
